<template>
  <div id="drop-zone-w-encryption">
    <input type="file" :multiple="multiple" @change="onChange" :accept="accept" ref="dropzoneInputRef">
    <div class="ui" v-if="files.length === 0">
      <font-awesome-icon icon="cloud-upload-alt" size="2x"/>
      <br>
      <button class="btn btn-sm">{{t('Upload Files')}}</button>
    </div>
    <div class="file-list" v-if="files.length > 0">
      <div v-for="(file, index) in files" :key="index" class="d-flex justify-content-between row" :class="{'text-danger': file.invalid, 'text-success': 'uploaded' === file.processing}">
        <span class="text-truncate">{{file.name}}</span>
        <span v-if="file.invalidSize">{{t('File too large')}}: {{file.formattedSize}}MB</span>
        <span v-if="file.invalidType">{{t('Invalid file type')}}: {{file.type}}</span>
        <span v-if="!file.invalid">{{file.processing}}</span>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '../../../store/api'
  import { decryptValue, encryptValue } from '../patients/helper'

  export default {
    props: {
      apiUrl: {
        type: String,
      },
      multiple: {
        type: Boolean,
        default() {
          return false
        },
      },
      maxFilesize: {
        type: Number,
        default() {
          return 5
        },
      },
      acceptedFileTypes: {
        type: Array,
        default: function () {
          return [
            'image/*',
            'application/pdf',
            'application/vnd.ms-excel',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/rtf',
            'application/x-rar-compressed',
            'application/octet-stream',
            'application/zip',
            'multipart/x-zip',
            'application/x-zip-compressed',
          ]
        },
      },
    },
    data() {
      return {
        processing: false,
        files: [],
      }
    },
    watch: {
      files() {
        if (true === this.processing) {
          return
        }

        if (0 === this.files.length) {
          return
        }

        this.$nextTick(this.validateFiles)
      },
    },
    methods: {
      uploaded() {
        this.$emit('addedFile')
        this.clean()
      },
      onChange(event) {
        this.files = []

        const files = []

        for (let index = 0; index < event.target.files.length; index++) {
          files.push(event.target.files[index]);
        }

        this.files = files;
      },
      clean() {
        setTimeout(() => {
          this.files = []
          this.$refs.dropzoneInputRef.value = ''
        }, 3000)
      },
      validateFiles() {
        this.processing = true

        const files = []

        for (const index in this.files) {
          if (false === this.files.hasOwnProperty(index)) {
            continue;
          }
          const file = this.files[index]

          file.invalidSize = file.size > this.maxFilesize * (1024 * 1024)
          file.formattedSize = Math.round((file.size / (1024 * 1024)) * 100) / 100
          file.invalidType = !(this.acceptedFileTypes.includes(file.type) || file.type.match(/^image\//))
          file.invalid = file.invalidSize || file.invalidType
          file.processing = file.invalid ? 'invalid' : 'processing'

          files.push(file);
        }

        this.files = files;
        this.$nextTick(this.uploadFile)
      },
      uploadFile() {
        const fileToUploadIndex = this.files.findIndex(file => !file.invalid && 'processing' === file.processing)

        if (-1 === fileToUploadIndex) {
          this.uploaded()
          this.processing = false
          return
        }

        const fileToUpload = this.files[fileToUploadIndex]

        fileToUpload.processing = 'uploading'

        this.files.splice(fileToUploadIndex, 1, fileToUpload)

        const fileReader = new FileReader()
        fileReader.addEventListener('load', (event) => {
          const file = event.target.result;
          let loggedUser = this.$store.getters['account/userStore'].getLoggedUser();
          const payload = {
            file: encryptValue(this.$store,loggedUser,file),
            name: encryptValue(this.$store,loggedUser,fileToUpload.name),
            size: fileToUpload.size,
            contentType: fileToUpload.type,
            application_id: this.$route.params.id,
          };
          api.put(this.apiUrl, payload).then(response => {
              const fileIndex = this.files
              .findIndex(file => file.name === decryptValue(loggedUser,response.data[0].file))
            const file = this.files[fileIndex]

            file.processing = 'uploaded'
            this.files.splice(fileIndex, 1, file)

            this.$nextTick(this.uploadFile)
          }).catch(error => {
            console.log({error})
          })
        })
        fileReader.readAsDataURL(fileToUpload)
      },
    },
    computed: {
      accept() {
        return this.acceptedFileTypes.join(',')
      },
    },

  }
</script>
<style lang="scss">
  .file-row {
    min-height: 50px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.125);
    color: #000;

    &:hover {
      color: #000;
    }

    .file-col-image {
      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
      }
    }
  }
  #drop-zone-w-encryption {
    position: relative;
    padding: 20px 20px 15px;
    border: 1px dashed #cdd2d8;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    background-color: #fff;
    transition-property: background-color;
    transition-duration: .25s;
    transition-timing-function: cubic-bezier(.4, 0, 1, 1);

    * {
      cursor: pointer;
    }

    &:hover {
      background-color: #f4f4f4;
    }

    .ui {
      pointer-events: none;
      padding: 20px 20px 15px;
      text-align: center;
      border-radius: 4px;
      color: gray;

      button {
        font-size: 90%;
      }

      * {
        pointer-events: none;
      }
    }

    .file-list {
      pointer-events: all;
      span {
        font-size: 90%;
      }
    }

    input[type="file"] {
      opacity: 0;
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/private/applications/file-upload-with-encryption.vue